import { createFeatureSelector } from '@ngrx/store';
import { CORE_FEATURE_KEY, CoreState } from './core.state';

export const coreState = createFeatureSelector<CoreState>(CORE_FEATURE_KEY);
